export const Melting_DE = [
  [
    'Ein Gletscher entsteht',
    "Vor etwa 100'000 Jahren beginnt sich am abfallenden Rand des westantarktischen Festlandsockels Eis zu bilden.",
  ],

  [
    'Das Eis wird dicker',
    'Weil die Temperaturen zurückgehen und mehr Schnee fällt, wird das Eis lange Zeit dicker und drückt zunehmend auf den Boden unter dem Gletscher.',
  ],

  [
    'Die Folgen der Ozeanerwärmung',
    'Doch nun geschieht Folgendes: «Warmes» Wasser aus der Tiefe des Ozeans lässt das Eisschelf kollabieren, dringt zum westantarktischen Festland vor und unterspült den Eisschild.',
  ],

  [
    'Der Gletscher gerät unter Druck',
    'Das Festlandeis schmilzt, verliert die Haftung am Boden und gleitet ins Meer.',
  ],
  [
    'Der Kollaps beginnt',
    'Und während sich das Wasser aufgrund der retrograden Neigung immer tiefer unter den Gletscher frisst und das Eis vom Landesinneren her drückt, gleitet dieser immer weiter ab. Die vordere Gletscherwand kollabiert, und immer mehr Eis stürzt ins Meer – der Gletscher «kalbt».',
  ],
]
export const Melting_FR = [
  [
    "La formation d'un glacier",
    "Il y a environ cent mille ans de la glace commence à se former sur le bord incliné du plateau continental de l'Antarctique occidental.",
  ],

  [
    "La glace s'épaissit",
    "Comme les températures baissent et que la neige tombe en plus grande quantité, la glace s'épaissit sur une longue durée et exerce de plus en plus de pression sur le sol se trouvant sous le glacier.",
  ],

  [
    "Les conséquences du réchauffement de l'océan",
    "Voici ce qui se passe: de l'eau «chaude» provenant des profondeurs de l'océan fait effondrer la plateforme de glace, pénètre sur le continent de l'Antarctique occidental et érode la calotte polaire.",
  ],

  [
    'Le glacier subit une pression',
    'La glace continentale fond, perd son adhérence au sol et glisse vers la mer.',
  ],
  [
    "L'effondrement commence",
    "Et tandis que l'eau s'engouffre de plus en plus profondément sous le glacier en raison de l'inclinaison rétrograde et pousse la glace depuis l'intérieur des terres, le glacier dérive de plus en plus. La paroi antérieure du glacier s'effondre et de plus en plus de glace tombe dans la mer – le glacier «vêle». ",
  ],
]
